(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solea-header-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.vaynis-nav-group[open]').forEach(group=>{if(!group.contains(event.target))group.removeAttribute('open');});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.vaynis-nav-group[open]').forEach(group=>{group.removeAttribute('open');group.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solea-premium-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-vaynis-size]');if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const url=new URL(link.href);if(!link.hasAttribute('aria-current'))url.searchParams.set('filter.v.availability','1');link.href=url.toString();});
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-spc-sort]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-spc-filter-toggle]');
    if (toggle) {
      const filters = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!filters) return;
      const isOpen = filters.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) filters.querySelector('a, input, button')?.focus();
      return;
    }
    const close = event.target.closest('[data-spc-filter-close]');
    if (close) {
      const filters = close.closest('.spc__filters');
      if (!filters) return;
      filters.classList.remove('is-open');
      const toggleButton = document.querySelector('[aria-controls="' + filters.id + '"]');
      toggleButton?.setAttribute('aria-expanded', 'false');
      toggleButton?.focus();
      return;
    }
    const swatch = event.target.closest('[data-spc-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-spc-card]');
    if (!card) return;
    card.querySelectorAll('[data-spc-swatch]').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));
    const image = card.querySelector('.spc__card-image');
    if (image && swatch.dataset.imageUrl) {
      image.removeAttribute('srcset');
      image.src = swatch.dataset.imageUrl;
      image.alt = swatch.dataset.imageAlt || image.alt;
    }
    card.querySelectorAll('[data-spc-card-link]').forEach((link) => link.href = swatch.dataset.productUrl || link.href);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.spc__filters.is-open').forEach((filters) => {
      filters.classList.remove('is-open');
      const toggleButton = document.querySelector('[aria-controls="' + filters.id + '"]');
      toggleButton?.setAttribute('aria-expanded', 'false');
      toggleButton?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solea-product-intro"] && !Shopify.designMode) return;
  try {
    
const translateVaynisReviews=()=>{const source=document.querySelector('[data-vaynis-reviews-heading]');if(!source)return;const labels={'Customer Reviews':source.dataset.vaynisReviewsHeading,'Write a review':source.dataset.vaynisReviewAction};document.querySelectorAll('.jdgm-widget').forEach(widget=>{const walker=document.createTreeWalker(widget,NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){const text=node.nodeValue.trim();if(labels[text]&&labels[text]!==text)node.nodeValue=node.nodeValue.replace(text,labels[text]);}});};
translateVaynisReviews();let vaynisReviewQueued=false;new MutationObserver(()=>{if(vaynisReviewQueued)return;vaynisReviewQueued=true;requestAnimationFrame(()=>{vaynisReviewQueued=false;translateVaynisReviews();});}).observe(document.body,{childList:true,subtree:true});

  } catch(e) { console.error(e); }
})();
})();
